import React from 'react';
import Chip from '@material-ui/core/Chip';
import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { pluralize } from '../../lib/helpers/text.helpers';
import { messages } from './format-template.messages';

interface IFormatTemplateCountChipsProps {
  sessionTotal?: number | null;
  groupCount?: number | null;
  teamCount?: number | null;
}

// The count chips shared by the template card's pills and the preview modal's band rows, so both
// read the same wording. A chip is omitted at an absent or zero count; the caller owns the layout.
export const FormatTemplateCountChips: React.FC<IFormatTemplateCountChipsProps> = ({
  sessionTotal,
  groupCount,
  teamCount,
}) => (
  <>
    {sessionTotal ? (
      <Chip
        size="small"
        label={(
          <IntlMsg
            {...messages.assessmentSessions}
            values={{ count: sessionTotal, sessionWord: pluralize(sessionTotal, 'ice time') }}
          />
        )}
      />
    ) : null}
    {groupCount ? (
      <Chip
        size="small"
        label={(
          <IntlMsg
            {...messages.groups}
            values={{ count: groupCount, groupWord: pluralize(groupCount, 'group') }}
          />
        )}
      />
    ) : null}
    {teamCount ? (
      <Chip
        size="small"
        label={(
          <IntlMsg
            {...messages.teams}
            values={{ count: teamCount, teamWord: pluralize(teamCount, 'team') }}
          />
        )}
      />
    ) : null}
  </>
);
